import { connect } from 'react-redux'
import ExamplesSection from './examples-section'
import { getExamplesList } from '../../../../../stores/examples/examples.selectors'

const mapStateToProps = state => ({
  examples: getExamplesList(state)
})

export default connect(
  mapStateToProps,
  null
)(ExamplesSection)
